import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SUPPORTED_LANGS, LANG_LABELS } from "@/i18n";

export const LanguageSwitcher = ({ dark = false }) => {
  const { lang = "fr" } = useParams();
  const [open, setOpen] = useState(false);

  const switchTo = (lg) => {
    localStorage.setItem("fastority_lang", lg);
    const rest = window.location.pathname.split("/").slice(2).join("/");
    window.location.href = `/${lg}${rest ? `/${rest}` : ""}`;
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher-button"
          className={`flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-medium transition-colors ${
            dark ? "text-white/80 hover:text-white" : "text-slate-700 hover:text-deepblue"
          }`}
        >
          <Globe size={16} strokeWidth={2} />
          <span className="uppercase">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {SUPPORTED_LANGS.map((lg) => (
          <DropdownMenuItem
            key={lg}
            data-testid={`language-option-${lg}`}
            onClick={() => switchTo(lg)}
            className="flex items-center justify-between cursor-pointer"
          >
            {LANG_LABELS[lg]}
            {lg === lang && <Check size={14} />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
